import { Injectable, inject } from '@angular/core';

import { LocalStoreService } from '@frontend/vanilla/core';

import { CdnaUserProfileStore } from './model';

@Injectable({ providedIn: 'root' })
export class CustomerDnaProfileStorageService {
    private localStoreService = inject(LocalStoreService);

    private readonly customerTopSportsKey = 'topSports';

    set customerDnaTopSports(topSports: CdnaUserProfileStore) {
        this.localStoreService.set<CdnaUserProfileStore>(this.customerTopSportsKey, topSports);
    }

    get customerDnaTopSports(): CdnaUserProfileStore | null {
        return this.localStoreService.get<CdnaUserProfileStore>(this.customerTopSportsKey);
    }
}
